import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  standalone: false
})
export class NavbarComponent implements OnInit {
  login = false;
  admin = false;

  constructor(
    private router: Router,
    private location: Location,
    private auth: AuthService
  ) {}

  ngOnInit() {
    // 👇 inicializar estado desde localStorage (por si ya está logueado)
    this.admin = this.auth.autenticado();

    // 👇 suscripción reactiva: se actualiza en caliente sin reload
    this.auth.authState$.subscribe((state) => {
      this.admin = state;
    });

    // 👇 ejemplo de detección de que estás en /admin
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.login = event.urlAfterRedirects.startsWith('/admin');
      }
    });
  }

  closeNavbar() {
    const navbar = document.getElementById('myNavbar');
    if (navbar && navbar.classList.contains('show')) {
      navbar.classList.remove('show'); // cierra el collapse
    }

  }
}